import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { Text, Heading2, FullWidthSection, MaxContentWidthWrapper, MaxContentWidthContainer, GridRow, Heading4, Heading1, BiggerText } from './MarketingStyles';

import { inject, observer } from 'mobx-react'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

@inject('utilStore', 'translationStore')
@observer

class MotivationSection extends Component {

  constructor(props) {
    super(props)
    this.state = {
      index: 0
    }
  }

  render() {

    const quotes = this.props.utilStore.quotes
    const { isTablet, isPhone } = this.props.utilStore

    // if(quotes && quotes.length <= 2 && !isPhone) {
    //   quotes.push({ isPlaceholder: true })
    // }

    const newIndex = !isTablet ? this.state.index + 1 : this.state.index

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    return (
      <FullWidthSection id="motivation">
        <MaxContentWidthWrapper>
          <MaxContentWidthContainer>
            <GridRow
              desktop="1fr 1fr"
              tablet="1fr"
            >
              <div>
                <Heading1>{ text('marketing_motivation_headline') }</Heading1>
                <BiggerText>
                  { text('marketing_motivation_subheadline') }
                </BiggerText>
              </div>
            </GridRow>
          </MaxContentWidthContainer>
        </MaxContentWidthWrapper>
        <MotivationWrapper background="https://res.cloudinary.com/theloge/image/upload/q_auto/w_2000/v1628577896/marketing/Porsche_Sky_Removed.jpg">

          <MaxContentWidthWrapper>
            <MaxContentWidthContainer>

              <QuoteCarousel
                key="press-carousel"
                autoPlay interval={4000} stopOnHover={false} infiniteLoop centerMode centerSlidePercentage={ isTablet ? "100" : "33.3" } showArrows={false} showStatus={false} showIndicators={false} showThumbs={false}
                onChange={ index => this.setState( { index: !isTablet ? index - 1 : index } ) }
                selectedItem={ newIndex }
              >
                { quotes && quotes.map((item, index) => {
                  return item.isPlaceholder ?
                    <div></div>
                    :
                    <MotivationItem key={ 'motivationquote' + index }>
                      <MotivationQuote>
                        „{ item.quote }“
                      </MotivationQuote><br />
                      <MotivationAuthor> { item.author } </MotivationAuthor>
                    </MotivationItem>
                })}
              </QuoteCarousel>

              {/* <MotivationSectionContent>
                { quotes && quotes.map((item, index) => (
                  <MotivationItem key={ 'motivationquote' + index }>
                    <MotivationQuote>
                      „{ item.quote }“
                    </MotivationQuote><br />
                    <MotivationAuthor> { item.author } </MotivationAuthor>
                  </MotivationItem>
                ))}
              </MotivationSectionContent> */}

            </MaxContentWidthContainer>
          </MaxContentWidthWrapper>
        </MotivationWrapper>
      </FullWidthSection>
    )
  }
}

export default MotivationSection

const QuoteCarousel = styled(Carousel) `
  margin: 0 -30px;

  .slide {
    max-width: 33.3%;
  }
`

const MotivationWrapper = styled.div `
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${ props => props.background });

  width: 100%;
  height: 550px;

  padding: 50px 0;
  margin: 50px 0;
`

const MotivationSectionContent = styled.div `
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 50px;

  ${cssVar.breakpoints.tablet} {
    grid-template-columns: 1fr 1fr;
  }
`

const MotivationItem = styled.div `
  margin: 0 30px;
  text-align: left;
`

const MotivationQuote = styled(Heading2) `
  padding: 0;
  display: inline;
  background-color: ${ cssVar.colors.lightest_grey };
  box-shadow: 5px 0 0 ${ cssVar.colors.lightest_grey }, -5px 0 0 ${ cssVar.colors.lightest_grey };
  box-decoration-break: clone;
  line-height: 140%;

  ::after {
    content: "";
    height: 0;
    margin-top: -10px;
    width: 100%;
    display: block;
  }
`

const MotivationAuthor = styled(Text) `
  padding: 0;
  display: inline;
  background-color: ${ cssVar.colors.lightest_grey };
  box-shadow: 5px 0 0 ${ cssVar.colors.lightest_grey }, -5px 0 0 ${ cssVar.colors.lightest_grey };
`



// WEBPACK FOOTER //
// /src/components/marketing/MotivationSection.js